import React from 'react';
import { Calendar, Briefcase, Award, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Card, CardContent, CardHeader } from '../ui/card';
import { Badge } from '../ui/badge';

const Experience = ({ data }) => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  return (
    <section id="experience" className="py-24 px-4 sm:px-6 lg:px-8" ref={ref}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl sm:text-6xl font-bold text-white mb-4 tracking-tight">
            Work Experience
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-500 to-teal-400 mx-auto mb-6" />
          <p className="text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed">
            Building impactful products at leading companies, from enterprise platforms to innovative startups
          </p>
        </div>

        <div className="space-y-8">
          {data.map((job, index) => (
            <div key={job.id} className="relative">
              <div className="bg-gradient-to-br from-gray-900/60 to-gray-900/40 border border-gray-800/50 rounded-xl p-8 hover:border-emerald-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-emerald-500/10">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6 mb-6">
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      {job.position}
                    </h3>
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-emerald-400 font-semibold text-lg">
                        {job.company}
                      </span>
                    </div>
                    <p className="text-gray-400 text-base leading-relaxed mb-4">
                      {job.description}
                    </p>
                  </div>
                  <div className="flex items-center text-gray-300 text-sm bg-gray-800/60 px-4 py-2 rounded-lg border border-gray-700/50 whitespace-nowrap font-medium">
                    <Calendar className="h-4 w-4 mr-2 text-emerald-400" />
                    {job.duration}
                  </div>
                </div>
                
                <ul className="space-y-3 pt-6 border-t border-gray-800/50">
                  {job.achievements.map((achievement, achievementIndex) => (
                    <li key={achievementIndex} className="flex items-start text-gray-300 text-sm leading-relaxed">
                      <span className="text-emerald-400 mr-3 mt-0.5 flex-shrink-0 font-bold">•</span>
                      <span className="flex-1">{achievement}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;